// extracted by mini-css-extract-plugin
export var brand = "_ax-9";
export var compact = "_ax-6";
export var extraSmall = "_ax-7";
export var icon = "_ax-0";
export var large = "_ax-4";
export var light = "_ax-1";
export var medium = "_ax-5";
export var outline = "_ax-b";
export var primaryDark = "_ax-a";
export var primaryLight = "_ax-8";
export var primaryModern = "_ax-c";
export var success = "_ax-2";
export var successSolid = "_ax-3";